const selectors = {
    days: '[data-days]',
    hours: '[data-hours]',
    minutes: '[data-minutes]',
    seconds: '[data-seconds]',
    message: '.js-countdown-message',
    countdown: '.js-countdown-holder',
};

const attributes = {
    dataStart: 'data-time-start',
    dataEnd: 'data-time-end',
    hideAfterEnd: 'data-expiration-behavior',
};

const classes = {
    end: 'hidden',
};

class CountdownHolder extends HTMLElement {
    constructor() {
        super();

        this.startDate = Number(this.getAttribute(attributes.dataStart));
        this.endDate = Number(this.getAttribute(attributes.dataEnd));
        this.timeZone = 'UTC−04:00';
        this.offset = this.timeZone.replace('UTC', '');
        this.expirationHide = this.getAttribute(attributes.hideAfterEnd);
        this.countdownHolder = this.querySelector(selectors.countdown);
        this.messageHolder = this.querySelector(selectors.message);

        this.days = this.querySelector(selectors.days);
        this.hours = this.querySelector(selectors.hours);
        this.minutes = this.querySelector(selectors.minutes);
        this.seconds = this.querySelector(selectors.seconds);

        this.hoursOffset = 0;
        if (!this.startDate && !this.endDate) {
            this.parentElement.classList.remove(classes.end);
        }
        if (this.startDate && this.endDate) {
            this.init();
        }

    }

    init() {
        this.setTimezoneDiff();
        this.countdown();
    }

    setTimezoneDiff() {
        const timeZoneParts = this.offset.match(/([+−]?)(\d+):(\d+)/);

        const sign = timeZoneParts[1] === '−' ? -1 : 1;
        const hours = parseInt(timeZoneParts[2], 10);
        const minutes = parseInt(timeZoneParts[3], 10);

        // Calculate the total offset in hours as a decimal
        this.hoursOffset = sign * (hours + minutes / 60);
    }

    countdown() {
        const today = new Date();
        const UTC = this.getUTCDate(today);
        const countdownServerTime = UTC + this.hoursOffset * 60 * 60 * 1000;

        if (this.endDate > countdownServerTime) {
            let diff = this.endDate - countdownServerTime;

            const timer = setInterval(() => {
                diff -= 1000;
                const todayDate = new Date();
                const UTCNow = this.getUTCDate(todayDate);
                const serverTimeNow = UTCNow + this.hoursOffset * 60 * 60 * 1000;

                if (diff < 0) {
                    clearInterval(timer);
                    if (this.expirationHide !== 'hide') {
                        this.parentElement.querySelector('.countdown__content').classList.add(classes.end);
                    }

                    window.dispatchEvent(new CustomEvent('theme:countdown:end'));

                    return;
                }

                if (this.startDate > serverTimeNow || this.endDate < this.startDate) {
                    this.parentElement.querySelector('.countdown__content').classList.add(classes.end);
                    window.dispatchEvent(new CustomEvent('theme:countdown:end'));
                    return;
                }

                this.parentElement.classList.remove(classes.end);
                this.days.innerText = this.formatValue(Math.floor(diff / (1000 * 60 * 60 * 24)));
                this.hours.innerText = this.formatValue(Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)));
                this.minutes.innerText = this.formatValue(Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60)));
                this.seconds.innerText = this.formatValue(Math.floor((diff % (1000 * 60)) / 1000));
            }, 1000);
        } else if (this.expirationHide !== 'hide') {
            window.dispatchEvent(new CustomEvent('theme:countdown:end'));
            this.parentElement.querySelector('.countdown__content').classList.add(classes.end);
        }
    }

    getUTCDate(point) {
        return Date.UTC(
            point.getUTCFullYear(),
            point.getUTCMonth(),
            point.getUTCDate(),
            point.getUTCHours(),
            point.getUTCMinutes(),
            point.getUTCSeconds(),
            point.getUTCMilliseconds()
        );
    }
    formatValue(value) {
        // Add leading zero if value is less than 10
        return value < 10 ? `0${value}` : value;
    }
}

customElements.get('countdown-holder') || customElements.define('countdown-holder', CountdownHolder);
